import * as signals from '../states/signals'
import { Signal, signal$ } from '@rwwa/rwwa-rx-state-machine'
import { selectAcceptor } from '../integration'

let sideEffects: Rx.IDisposable

export function registerOddsSideEffects() {
  sideEffects = signal$.takeUntil(signals.Teardown.signal$).subscribe((signal: Signal) => {
    if (signal.tag === signals.SelectAcceptor) {
      selectAcceptor(signal.data.acceptorNumber, signal.data.isFixed)
    }
  })
}

export function deregisterOddsSideEffects() {
  sideEffects.dispose()
}
